<template>
    <div class="wui-container lifestyle-list">
        <div class="header">
            <!-- 标签 -->
            <div class="tags">
                <div class="tag-list">
                    <div
                        class="tag-item"
                        :class="{'tag-active': item.isSelected}"
                        @click="selectTag(item)"
                        v-for="(item) in tagList"
                        :key="item.id"
                    >{{item.name}}</div>
                    <!-- <div class="tag-item"></div> -->
                </div>
            </div>
            <!-- 城市 -->
            <!-- <div class="city">
                <div class="current" @click="cityDialog">
                    <span class="name">{{currentCity.id ? currentCity.name : $t('城市')}}</span>
                    <span class="iconfont icon-trigon"></span>
                </div>
                <div class="city-list" v-if="cityDialogVisible">
                    <div
                        class="city-item"
                        :class="{'city-active': item.isSelected}"
                        @click="selectCity(item)"
                        v-for="(item) in cityList"
                        :key="item.id"
                    >{{item.name}}</div>
                </div>
            </div> -->
        </div>

        <!-- 列表 -->
        <van-list
            v-model:loading="loading"
            :finished="finished"
            :loading-text="$t('加载中')"
            @load="onLoad"
        >
            <div class="list">
                <div class="list-col left">
                    <LifestyleItem v-for="item in leftList" :key="item.id" :info="item"></LifestyleItem>
                </div>
                <div class="list-col right">
                    <LifestyleItem v-for="item in rightList" :key="item.id" :info="item"></LifestyleItem>
                </div>
            </div>
        </van-list>

        <HomeButton></HomeButton>
    </div>
</template>

<script>
import { List } from 'vant';

import api from "@/api/index";
import LifestyleItem from "@/components/LifestyleItem.vue";
import HomeButton from "@/components/HomeButton.vue";
import { initWechatJSSDK } from "@/assets/wechat.js"

export default {
    components: {
        VanList: List,
        LifestyleItem,
        HomeButton
    },
    data() {
        return {
            tagList: [], // 标签列表
            currentTag: {}, // 当前标签

            cityList: [], // 城市列表
            currentCity: {}, // 当前城市
            cityDialogVisible: false,

            pn: 0,
            ps: 20,
            loading: false,
            finished: false,
            leftHeight: 0,
            rightHeight: 0,
            leftList: [],
            rightList: []
        };
    },
    mounted() {
        this.getTagList();
        this.getCityList();

        initWechatJSSDK({
            title: 'Wellcee · Lifestyle',
            desc: this.$t('Wellcee的小伙伴们分享了好多有趣的故事和瞬间呢'),
            imgUrl: 'https://qnimg1.wellcee.com/app.png'
        });
    },
    methods: {
        // 加载
        onLoad(){
            if (this.finished) {
                return false;
            }
            this.pn++;
            this.getLifestyleList();
        },
        // 刷新
        onRefresh(){
            window.scrollTo(0,0);
            this.pn = 1;
            this.loading = true;
            this.finished = false;
            this.leftHeight = 0;
            this.rightHeight = 0;
            this.leftList = [];
            this.rightList = [];
            this.getLifestyleList();
        },
        // 获取Lifestyle列表
        getLifestyleList() {
            let params = {
                page: this.pn,
                count: this.ps,
                order: "weekly_weight"
            };
            if (this.currentCity.id) {
                params.city_id = this.currentCity.id;
            }
            if (this.currentTag.id) {
                params.tag_id = this.currentTag.id;
            }
            // console.log(params);
            api.lifestyle.get(params).then(res => {
                let data = res.data;

                let leftHeight = this.leftHeight;
                let rightHeight = this.rightHeight;
                let leftList = this.leftList;
                let rightList = this.rightList;

                data.forEach(item => {
                    item.width = item.cover.width;
                    item.height = item.cover.height;

                    if (item.height / item.width > 1) {
                        item.rectangle = true;
                    }
                    if (rightHeight >= leftHeight) {
                        leftList.push(item);
                        if (item.rectangle) {
                            leftHeight += 1.5;
                        } else {
                            leftHeight += 1;
                        }
                    } else {
                        rightList.push(item);
                        if (item.rectangle) {
                            rightHeight += 1.5;
                        } else {
                            rightHeight += 1;
                        }
                    }
                });
                if (data.length < this.ps) {
                    this.finished = true;
                }
                
                this.leftHeight = leftHeight;
                this.rightHeight = rightHeight;
                this.leftList = leftList;
                this.rightList = rightList;
                this.$nextTick(()=>{
                    this.loading = false;
                })
            });
        },
        // 获取Lifestyle 标签列表
        getTagList() {
            api.lifestyle.getTagList().then(res => {
                res.data.forEach(item => {
                    item.isSelected = false;
                });
                res.data.unshift({
                    id: 0,
                    name: this.$t('推荐'),
                    isSelected: true
                });
                this.tagList = res.data;
            });
        },
        // 选择标签
        selectTag(row) {
            if (row.id != 0) {
                this.$router.push(`/lifestyle/tag?tag=${decodeURIComponent(row.name)}`)
            }
            // this.tagList.forEach(item => {
            //     item.isSelected = false;
            // });
            // row.isSelected = true;
            // this.currentTag = row;
            this.onRefresh();
        },
        // 获取城市列表
        getCityList() {
            api.lifestyle.getCityList().then(res => {
                res.data.forEach(item => {
                    item.isSelected = false;
                });
                res.data.unshift({
                    id: 0,
                    name: this.$t('不限'),
                    isSelected: true
                });
                this.cityList = res.data;
            });
        },
        // 城市弹窗
        cityDialog() {
            this.cityDialogVisible = !this.cityDialogVisible;
        },
        // 选择城市
        selectCity(row) {
            this.cityList.forEach(item => {
                if (row.id === item.id) {
                    item.isSelected = !item.isSelected;
                    if (item.isSelected) {
                        this.currentCity = item;
                    } else {
                        this.currentCity = {
                            id: "",
                            name: "不限", // 不限 language.get('lifestyle33')
                            isSelected: true
                        };
                        this.cityList[0].isSelected = true;
                    }
                } else {
                    item.isSelected = false;
                }
            });

            this.cityDialogVisible = false;
            this.onRefresh();
        }
    },
};
</script>

<style scoped>
.mask-layer {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.1);
    z-index: 100;
}
.header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 50px;
    padding: 0 12px;
    display: flex;
    align-items: center;
    background-color: #ffffff;
    z-index: 1000;
    max-width: 500px;
    margin: 0 auto;
}
.header .tags {
    height: 50px;
    overflow-x: auto;
}
.header .tag-list {
    display: flex;
    height: 50px;
}
.header .tag-item {
    display: flex;
    align-items: center;
    padding: 0 7px;
    height: 26px;
    background: rgba(17, 17, 17, 0.03);
    border-radius: 6px;
    margin-right: 15px;
    margin-top: 12px;

    font-size: 14px;
    color: #111111;
    white-space: nowrap;
}

.header .tag-active {
    color: rgba(45, 182, 180, 1);
    background: rgba(45, 182, 180, 0.05);
}
/* .header .tag-item:last-child {
    min-width: 55px;
    background-color: transparent;
} */
.header .city {
    position: absolute;
    right: 0;
    top: 0;
}
.header .city .current {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    height: 50px;
    width: 95px;
    padding-right: 10px;
    background: linear-gradient(
        270deg,
        #ffffff 60.75%,
        rgba(255, 255, 255, 0) 90.53%
    );
}
.header .city .current .name {
    font-size: 15px;
    color: #111111;
    margin-right: 5px;
}
.header .city .current .icon-trigon {
    font-size: 6px;
    color: #a3b1c1;
}
.header .city-list {
    position: absolute;
    top: 50px;
    right: 15px;
    width: 124px;
    background: #ffffff;
    box-shadow: 0px 15px 30px rgba(0, 0, 0, 0.2);
    border-radius: 6px;
    padding: 10px 0;
    z-index: 1002;
}
.header .city-list .city-item {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    font-size: 15px;
    color: #111111;
}
.header .city-list .city-active {
    color: #2db6b4;
    background: rgba(45, 182, 180, 0.05);
}

.list {
    display: flex;
    align-items: flex-start;
    padding: 70px 15px 20px 15px;
}
.list .list-col {
    width: 50%;
    overflow: hidden;
}
.list .left {
    margin-right: 13px;
}
</style>
